import React from 'react'
import { ChatbotStepActionData, removeContactActionData, saveContactActionData } from '../../../../models/flowBuilderTypes';
import { Grid, Typography } from '@mui/material';
import formStyles from './../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import globalStyles from "../../../../assets/styles/global.module.scss";
import { ACTION_TYPE_NAME } from '../flowBuilderConstants';
import { getContactListPageUrl } from '../../../../utils/constants';

interface SaveAndRemoveContactNodeProps {
    id: string, 
    data: ChatbotStepActionData<saveContactActionData | removeContactActionData>
} 

const SaveAndRemoveContactNode: React.FC<SaveAndRemoveContactNodeProps> = (props) => {
    
    const { id, data } = props;

    const getTitleAndDescriptionObj = (title: string, description: string) => {
        return {
            title: title,
            description: description
        }
    }

    const getSaveAndRemoveContactTitleAndDescription = () => {
        if(data?.action_type?.action_type_name == ACTION_TYPE_NAME["SAVE_CONTACT"]){
            if(data?.action_data?.action_contact_list_id){
                return getTitleAndDescriptionObj("Save contact in", data?.action_data?.contact_list_name);
            } else {
                return getTitleAndDescriptionObj("Save Contact", "Please configure contact list");
            }
        } else {
            if(data?.action_data?.action_contact_list_id){
                return getTitleAndDescriptionObj("Remove contact from", data?.action_data?.contact_list_name);
            } else {
                return getTitleAndDescriptionObj("Remove Contact", "Please configure contact list");
            }
        }
    }

    return (
        <>
            <Grid item>
                <Grid container className={`${globalStyles.displayFlexStyle} ${globalStyles.flexColumn}`}>
                    <Grid item>
                        <Typography className={formStyles.dataSavedTextStyle}>
                            {getSaveAndRemoveContactTitleAndDescription()?.title}
                        </Typography>
                    </Grid>
                    <Grid item>
                        {data?.action_data?.action_contact_list_id ? 
                            <a href={getContactListPageUrl(data?.action_data?.action_contact_list_id)} target='blank' className={`${formStyles.contactListAnchorTag} ${globalStyles.primaryFontSize} ${globalStyles.secondaryFontWeight}`}>
                                {getSaveAndRemoveContactTitleAndDescription()?.description}
                            </a>
                            :
                            <Typography className={formStyles.dataSavedValueStyle}>
                                {getSaveAndRemoveContactTitleAndDescription()?.description}
                            </Typography>
                        }
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default SaveAndRemoveContactNode
